<template>
  <v-layout column>
    <h3>{{ editMode ? "Update Fixed Cost Trip" : "Create new Fixed Cost Trip" }}</h3>
    <v-flex align-center justify-center>
      <form>
        <v-text-field
          v-model="form.name"
          :error-messages="nameErrors"
          label="Name"
          required
          maxlength="60"
          @input="$v.form.name.$touch()"
          @blur="$v.form.name.$touch()"
        ></v-text-field>
        <v-text-field
          v-model="form.nameForCustomer"
          :error-messages="nameForCustomerErrors"
          maxlength="60"
          label="Name for Customer"
          required
          @input="$v.form.nameForCustomer.$touch()"
          @blur="$v.form.NameForCustomer.$touch()"
        ></v-text-field>
        <LocationInput
          @locationChanged="pickupChanged"
          id="pickup"
          label="Pickup Location"
          v-model="pickupLocation"
        />
        <LocationInput
          @locationChanged="destinationChanged"
          id="destination"
          label="Destination Location"
          v-model="destinationLocation"
        />
        <v-switch v-if="editMode" v-model="form.enabled" label="Enabled" required></v-switch>
        <v-flex pt-3 pb-4 pl-2>
          <v-layout row>
            <AreaPolygonMap ref="areaMap"></AreaPolygonMap>
            <v-flex xs3 px-4>
              <v-layout column>
                <v-flex py-1>
                  <v-btn
                    :disabled="pickupPolygon == null"
                    class="text-none"
                    color="red lighten-2"
                    dark
                    @click="resetPickup"
                  >Reset Pickup Area</v-btn>
                </v-flex>
                <v-btn
                  :disabled="destinationPolygon == null"
                  class="text-none"
                  color="green lighten-2"
                  dark
                  @click="resetDestination"
                >Reset Destination Area</v-btn>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-btn
          class="text-none"
          large
          color="green lighten-2"
          dark
          @click="submit"
        >{{ editMode ? "Update Fixed Cost Trip" : "Create Fixed Cost" }}</v-btn>
      </form>
    </v-flex>
  </v-layout>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, maxLength, email } from "vuelidate/lib/validators";

import LocationInput from "@/components/widget/input/LocationInput.vue";
import AreaPolygonMap from "@/components/widget/AreaPolygonMap.vue";
// import { setTimeout } from "timers";

export default {
  name: "fixed_cost_area_details",
  components: {
    LocationInput,
    AreaPolygonMap
  },
  props: {
    loading: { type: Boolean, default: false },
    editMode: { type: Boolean, default: false },
    fixedCostAreaSummary: { type: Object, default: null }
  },
  data: function() {
    return {
      pickupLocation: { id: null },
      destinationLocation: { id: null },
      form: {
        name: "",
        nameForCustomer: "",
        enabled: true
      },
      pickupPolygon: null,
      destinationPolygon: null,
      map: null
    };
  },
  validations: {
    form: {
      name: { required },
      nameForCustomer: { required }
    }
  },
  beforeMount: function() {
    if (this.fixedCostAreaSummary != null) {
      this.form.name = this.fixedCostAreaSummary.name;
      this.form.nameForCustomer = this.fixedCostAreaSummary.name_for_customer;
      this.form.enabled = this.fixedCostAreaSummary.enabled;

      this.pickupLocation = this.fixedCostAreaSummary.pickup_location.location;
      this.pickupLocation.latLng = {
        latitude: this.pickupLocation.lat,
        longitude: this.pickupLocation.lon
      };
      this.destinationLocation = this.fixedCostAreaSummary.destination_location.location;
      this.destinationLocation.latLng = {
        latitude: this.destinationLocation.lat,
        longitude: this.destinationLocation.lon
      };
    }
  },
  mounted: function() {
    var populatePolygons = this.populatePolygons;

    // TODO dont set timeout, actually wait for the map to load using a callback!
    setTimeout(function() {
      populatePolygons();
    }, 500);
  },

  computed: {
    nameErrors() {
      const errors = [];
      if (!this.$v.form.name.$dirty) return errors;
      !this.$v.form.name.required && errors.push("Name is required.");
      return errors;
    },
    nameForCustomerErrors() {
      const errors = [];
      if (!this.$v.form.nameForCustomer.$dirty) return errors;
      !this.$v.form.nameForCustomer.required &&
        errors.push("Name for customer is required.");
      return errors;
    }
  },
  methods: {
    submit: function() {
      this.$v.form.$touch();

      if (this.$v.form.$pending || this.$v.form.$error) return;

      if (this.pickupPolygon == null || this.destinationPolygon == null) {
        return;
      }

      if (
        this.pickupLocation.id == null ||
        this.destinationLocation.id == null
      ) {
        return;
      }

      // alert("Form Submitted");

      var fixedCostAreaSummary = {};

      fixedCostAreaSummary.name = this.form.name;
      fixedCostAreaSummary.name_for_customer = this.form.nameForCustomer;

      fixedCostAreaSummary.pickup_name = this.pickupLocation.description;
      fixedCostAreaSummary.destination_name = this.destinationLocation.description;

      fixedCostAreaSummary.pickup_location = this.pickupLocation.id;
      fixedCostAreaSummary.destination_location = this.destinationLocation.id;

      if (this.editMode) {
        fixedCostAreaSummary.enabled = this.form.enabled;
      }

      fixedCostAreaSummary.pickup_polygon = JSON.stringify(
        this.coordsToServerCoordinateFormat(this.pickupPolygon)
      );

      fixedCostAreaSummary.destination_polygon = JSON.stringify(
        this.coordsToServerCoordinateFormat(this.destinationPolygon)
      );

      this.$emit("submitted", fixedCostAreaSummary);
    },
    coordsToServerCoordinateFormat: function(polygon) {
      var serverCoordinates = [];

      for (var i = 0; i < polygon.getPath().getLength(); i++) {
        serverCoordinates.push([
          polygon
            .getPath()
            .getAt(i)
            .lat(),
          polygon
            .getPath()
            .getAt(i)
            .lng()
        ]);
      }

      serverCoordinates.push([
        polygon
          .getPath()
          .getAt(0)
          .lat(),
        polygon
          .getPath()
          .getAt(0)
          .lng()
      ]);

      return serverCoordinates;
    },
    resetPickup: function() {
      this.pickupPolygon.setMap(null);
      this.pickupPolygon = null;

      this.pickupChanged();
    },
    resetDestination: function() {
      this.destinationPolygon.setMap(null);
      this.destinationPolygon = null;

      this.destinationChanged();
    },
    pickupChanged: function() {
      if (this.pickupPolygon == null) {
        this.pickupPolygon = this.movePolygon(
          this.pickupLocation.latLng,
          this.pickupPolygon,
          "#FF0000"
        );
      }
    },
    destinationChanged: function() {
      if (this.destinationPolygon == null) {
        this.destinationPolygon = this.destinationPolygon = this.movePolygon(
          this.destinationLocation.latLng,
          this.destinationPolygon,
          "#0000FF"
        );
      }
    },
    movePolygon: function(latLng, polygon, color) {
      var p = latLng;

      var coords = [];
      var offsetX = 0.0006;
      var offsetY = 0.0003;

      coords.push({ lat: p.latitude - offsetY, lng: p.longitude - offsetX });
      coords.push({ lat: p.latitude + offsetY, lng: p.longitude - offsetX });
      coords.push({ lat: p.latitude + offsetY, lng: p.longitude + offsetX });
      coords.push({ lat: p.latitude - offsetY, lng: p.longitude + offsetX });
      // coords.push({ lat: p.latitude - offsetY, lng: p.longitude - offsetX });

      console.log(coords);

      if (polygon != null) {
        polygon.setMap(null);
      }

      polygon = new google.maps.Polygon({
        paths: coords,
        editable: true,
        draggable: true,
        strokeColor: color
      });
      polygon.setMap(this.$refs.areaMap.map);

      this.$refs.areaMap.map.setCenter({ lat: p.latitude, lng: p.longitude });
      this.$refs.areaMap.map.setZoom(16.0);

      return polygon;
    },
    addPolygon: function(coords, polygon, color) {
      if (polygon != null) {
        polygon.setMap(null);
      }

      polygon = new google.maps.Polygon({
        paths: coords,
        editable: true,
        draggable: true,
        strokeColor: color
      });

      console.log(this.$refs.areaMap.map);
      polygon.setMap(this.$refs.areaMap.map);

      console.log("Restored polygon");

      return polygon;
    },
    populatePolygons: function() {
      console.log("Populating Polygons");

      var bounds = new google.maps.LatLngBounds();

      var pickupCoords = [];
      var pickupPolygonJSON = this.fixedCostAreaSummary.pickup_polygon;

      for (var i = 0; i < pickupPolygonJSON.length; i++) {
        pickupCoords.push({
          lat: pickupPolygonJSON[i][0],
          lng: pickupPolygonJSON[i][1]
        });

        bounds.extend({
          lat: pickupPolygonJSON[i][0],
          lng: pickupPolygonJSON[i][1]
        });
      }

      this.pickupPolygon = this.addPolygon(
        pickupCoords,
        this.pickupPolygon,
        "#FF0000"
      );

      var destinationCoords = [];
      var destinationPolygonJSON = this.fixedCostAreaSummary
        .destination_polygon;

      for (var i = 0; i < destinationPolygonJSON.length - 1; i++) {
        destinationCoords.push({
          lat: destinationPolygonJSON[i][0],
          lng: destinationPolygonJSON[i][1]
        });

        bounds.extend({
          lat: destinationPolygonJSON[i][0],
          lng: destinationPolygonJSON[i][1]
        });
      }

      this.destinationPolygon = this.addPolygon(
        destinationCoords,
        this.destinationPolygon,
        "#0000FF"
      );

      this.$refs.areaMap.map.fitBounds(bounds);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
